import { AbstractPmsApiService } from "./abstract.service";
import { PropertyChannelModel } from "../models";

/**
 * @abstract
 * @extends {AbstractPmsApiService<PropertyChannelModel>}
 */
export class PropertyChannelsService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:property/property-channels';
    }

    newModel(attributes) {

        return new PropertyChannelModel(attributes);
    }

    /**
     * @returns {Promise.<PropertyChannelModel>}
     */
    active(property) {

        const url = this.url({property: property.id}) + '/active';

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }

    save(property, model) {

        const url = this.url({property: property.id});

        return this.http
            .put(url, model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/property-channels.service.js